import React from 'react';
import {isRTL} from '../../../../../../../../../Localization';

const circleMargin = isRTL() ? {marginLeft: 8} : {marginRight: 8};

export const StatusIcon = ({color, hasMargin}: {color: string; hasMargin?: boolean}) => {
    return (
        <div
            style={{
                flexShrink: 0,
                width: 9,
                height: 9,
                borderRadius: '50%',
                backgroundColor: color || 'var(--secondary-200, #DDE2E6)',
                border: '1px solid var(--secondary-200, #DDE2E6)',
                ...(hasMargin ? circleMargin : {})
            }}
        />
    );
};
